<div class="d-flex flex-column">
    @if (isEditing() && selectedEndCustomer() === undefined) {
        <div class="d-flex align-items-center justify-content-between mt-4">
            <div class="weight-medium">Create contact</div>
            <telxl-button
                colour="light"
                class="ps-2"
                ngbTooltip="Directory"
                placement="top"
                (buttonClick)="viewDirectory()"
            >
                <i class="fa-light fa-address-book"></i>
            </telxl-button>
        </div>
    } @else if (!isActiveCustomerSelected()) {
        <div
            class="d-flex align-items-center justify-content-between nav-height"
        >
            <a
                class="weight-medium"
                tabindex="0"
                (click)="viewDirectory()"
                (keypress)="viewDirectory()"
            >
                <i class="fa-duotone fa-light fa-arrow-left pe-1"></i>
                Back
            </a>
            <div class="d-flex">
                @if (hasActiveEndCustomer()) {
                    <telxl-button
                        class="me-1"
                        colour="primary"
                        [outline]="true"
                        (buttonClick)="mergeCustomers()"
                    >
                        Merge
                    </telxl-button>
                }
                @if (canSwap()) {
                    <telxl-button
                        class="ms-1"
                        colour="primary"
                        [outline]="true"
                        (buttonClick)="makeActiveCustomer()"
                    >
                        Swap
                    </telxl-button>
                }
            </div>
        </div>
    }
    <div class="d-flex align-items-center justify-content-between mt-4">
        <div
            [ngClass]="
                isEditing()
                    ? 'w-60'
                    : isActiveCustomerSelected()
                      ? 'w-70'
                      : 'w-80'
            "
        >
            <end-customer-details-initials />
        </div>
        @if (isEditing()) {
            <div class="d-flex align-items-center w-35">
                <telxl-button
                    class="w-100"
                    colour="light"
                    (buttonClick)="performFormAction('cancel')"
                >
                    Cancel
                </telxl-button>
                <telxl-button
                    colour="primary"
                    class="w-100 ps-2"
                    [outline]="true"
                    [disabled]="(canSave$ | async) === false"
                    (buttonClick)="performFormAction('save')"
                >
                    Save
                </telxl-button>
            </div>
        } @else {
            <div
                class="d-flex align-items-center"
                [ngClass]="
                    hasCanUpdatePermission
                        ? isActiveCustomerSelected() && allowNavigation()
                            ? 'w-25'
                            : 'w-15'
                        : 'w-10'
                "
            >
                @if (hasCanUpdatePermission) {
                    <telxl-button
                        class="w-100"
                        colour="light"
                        (buttonClick)="performEdit()"
                    >
                        Edit
                    </telxl-button>
                }
                @if (isActiveCustomerSelected() && allowNavigation()) {
                    <telxl-button
                        colour="light"
                        class="ps-2"
                        ngbTooltip="Directory"
                        placement="top"
                        (buttonClick)="viewDirectory()"
                    >
                        <i class="fa-light fa-address-book"></i>
                    </telxl-button>
                }
            </div>
        }
    </div>
</div>
@if (isEditing()) {
    <div
        class="panel editing mt-4"
        [ngClass]="{
            creating: selectedEndCustomer() === undefined,
            'none-active': !isActiveCustomerSelected(),
        }"
    >
        <end-customer-details-form
            (updated)="onUpdated($event)"
            [isCreateCustomer]="!selectedEndCustomer()"
        />
    </div>
} @else {
    <div class="d-flex justify-content-center align-items-center">
        <telxl-tab
            alignment="centered"
            centeredPaddingX="2rem"
            [tabs]="tabs()"
            [selected]="selected"
            (selectedChange)="setSelected($event)"
            containerClass="d-inline-block"
            justifyContentClass="justify-content-end"
            tabPaddingY="0.3rem"
        />
    </div>
    @switch (selected) {
        @case ('profile') {
            <div
                class="panel mt-4"
                [ngClass]="{ 'none-active': !isActiveCustomerSelected() }"
            >
                <end-customer-details-form (updated)="onUpdated($event)" />
            </div>
        }
        @case ('history') {
            <div class="mt-4">
                <telxl-shared-activity-history-panel
                    [customer]="customer"
                    [height]="height()"
                />
            </div>
        }
    }
}
